export default __webpack_public_path__ + "static/media/person-icon.8b68ba16.png";